export default {"src":"/_next/static/media/calendar.ff6e3379.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};